var _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNoSearchResultsFor(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 72,
    height: 54,
    viewBox: "0 0 72 54",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.375 16.875C11.7537 16.875 11.25 17.3787 11.25 18C11.25 18.6213 11.7537 19.125 12.375 19.125C12.9963 19.125 13.5 18.6213 13.5 18C13.5008 17.7014 13.3825 17.4148 13.1714 17.2036C12.9602 16.9925 12.6736 16.8742 12.375 16.875",
    stroke: "#1F76FF",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M23.625 16.875C23.0037 16.875 22.5 17.3787 22.5 18C22.5 18.6213 23.0037 19.125 23.625 19.125C24.2463 19.125 24.75 18.6213 24.75 18C24.7508 17.7014 24.6325 17.4148 24.4214 17.2036C24.2102 16.9925 23.9236 16.8742 23.625 16.875",
    stroke: "#1F76FF",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M65.25 11.25V6.75C65.25 4.26472 63.2353 2.25 60.75 2.25H6.75C4.26472 2.25 2.25 4.26472 2.25 6.75V24.75C2.25 27.2353 4.26472 29.25 6.75 29.25H22.5",
    stroke: "#1F76FF",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M47.25 45C55.9485 45 63 37.9485 63 29.25C63 20.5515 55.9485 13.5 47.25 13.5C38.5515 13.5 31.5 20.5515 31.5 29.25C31.5 37.9485 38.5515 45 47.25 45Z",
    stroke: "#1F76FF",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M69.7497 51.7527L58.3857 40.3887",
    stroke: "#1F76FF",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoSearchResultsFor);
export default __webpack_public_path__ + "static/media/NoSearchResultsFor.30118daf0aff985ceeb28a61c4375972.svg";
export { ForwardRef as ReactComponent };